import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { TripSearchForm } from '../TripSearchWidget/TripSearchWidget';
import { validateTripSearch } from '../../utils/search.utils';
import { useSelector, useDispatch } from 'react-redux';
import useTripSearchWidget from '../../utils/useTripSearchWidget';
import BaseText from '../BaseText';
import { CommonProperties } from '../../styles';
import { openAlert } from '../../store/actions/alert';

import ChangeAirReceiptCard from '../changeRes/ChangeAirReceiptCard';
import { ScrollView } from 'react-native';
import { setSearchInput, tripSearch } from '../../store/actions/search';
import { Screens } from '../../constants/ScreenNames';
import WrapBottomColor from '../containers/WrapBottomColor';
import BottomButton from '../BottomButton';
import { selectFirstReceipt } from '../../store/selectors/mytrips.selector';

const ChangeResWidget = ({ route }) => {
  const dispatchRedux = useDispatch();
  const receiptResponse = useSelector(selectFirstReceipt);
  const airlistResponse = useMemo(() => {
    return receiptResponse?.AirResponseDetails ? [receiptResponse?.AirResponseDetails] : null;
  }, [receiptResponse]);

  const data = route?.params.data;
  const newState = route?.params.newState;
  const finalCriteria = route?.params.finalCriteria;

  const onSearch = (params) => {
    const selectedAirline = data[0]?.AirSegments[0]?.AirlineCode;
    const searchPayload = {
      searchCriteria: params.searchCriteria,
      hasAir: params.hasAir,
      hasCar: params.hasCar,
      hasHotel: params.hasHotel,
      hasRail: params.hasRail,
      airRequestType: finalCriteria.length || 0,
      airClassType: airlistResponse[0]?.AirLegs[0]?.AirSegments[0]?.AirCabinClass,
      noofCar: 1,
      noofRooms: 1,
      adultCount: 1,
      IsGeoAutocomplete: false, //GR
      GooglePlace: {}, //GR
      isGeoSearch: false, //HT
      latitude: undefined, //HT
      longitude: undefined, //HT
      IsCarAutoComplete: undefined, //CR
      ServiceType: '',
    };

    onSearchHandler(searchPayload, searchInputState);
  };

  const onSearchHandler = async (searchInput, searchInputState) => {
    searchInput.IschangeRes = true;
    const validationResult = validateTripSearch(searchInput);
    if (validationResult.isFailed) {
      dispatch(openAlert({ message: validationResult.msg }));
    } else {
      await dispatchRedux(setSearchInput(searchInput, searchInputState));
      dispatchRedux(tripSearch(Screens.TripHub, searchInputState, receiptResponse));
    }
  };

  const [
    { searchInputState, isNearbyHotelTonightSearch, handleSearchTypeChecked, onSubmit },
    dispatch,
  ] = useTripSearchWidget(false, onSearch, newState);
  return (
    <WrapBottomColor>
      <ScrollView style={styles.container}>
        {data &&
          data?.map((leg, index) => {
            return (
              <View key={index}>
                <ChangeAirReceiptCard item={leg} />
              </View>
            );
          })}
        <View
          style={{
            borderBottomColor: 'black',
            borderBottomWidth: 1,
          }}
        />
        <BaseText style={styles.text}>Search for flight(s)</BaseText>
        <TripSearchForm dispatch={dispatch} searchInputState={searchInputState} />
      </ScrollView>
      <BottomButton label="Search" full onPress={onSubmit} />
    </WrapBottomColor>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    ...CommonProperties.p3,
  },
  text: {
    textAlign: 'center',
    backgroundColor: 'white',
    ...CommonProperties.h4,
    ...CommonProperties.p3,
  },
});
export default ChangeResWidget;
